export const ERROR_CODES = {
  CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
  ROUTE_NOT_FOUND: 'ROUTE_NOT_FOUND',
  METHOD_NOT_ALLOWED: 'METHOD_NOT_ALLOWED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  INVALID_REQUEST: 'INVALID_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  NOT_FOUND: 'NOT_FOUND',
  FORBIDDEN: 'FORBIDDEN',
  RATE_LIMITED: 'RATE_LIMITED',

  // Auth (Phase 1). All non-existent contact / wrong-code / expired
  // responses collapse to INVALID_CREDENTIALS for enumeration-safety
  // (phase-1-3-AuthenticationPhase.md §5). The codes below are for
  // cases where the client genuinely did something wrong and we want
  // a more specific error envelope.
  HANDLE_UNAVAILABLE: 'HANDLE_UNAVAILABLE',
  HANDLE_INVALID: 'HANDLE_INVALID',
  CONTACT_INVALID: 'CONTACT_INVALID',
  OTP_LOCKED: 'OTP_LOCKED',
  OTP_EXPIRED: 'OTP_EXPIRED',
  OTP_REPLAY: 'OTP_REPLAY',
  RECEIPT_INVALID: 'RECEIPT_INVALID',
  SESSION_REVOKED: 'SESSION_REVOKED',
  STEP_UP_REQUIRED: 'STEP_UP_REQUIRED',
  TERMS_REQUIRED: 'TERMS_REQUIRED',
  AGE_REQUIREMENT_NOT_MET: 'AGE_REQUIREMENT_NOT_MET',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === 'string' && (ERROR_CODES as Record<string, string>)[value] === value;
}
